export default "__VITE_ASSET__b29d6abb__"